import { render } from "./CompaniaDatos.vue?vue&type=template&id=7e942b11"
import script from "./CompaniaDatos.vue?vue&type=script&lang=js"
export * from "./CompaniaDatos.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__